import React from 'react'

import news_exception from '@/assets/common/news_exception.png'
import { hostImageServer } from '@/shared/api'
import Loading from '@/shared/components/common/Loading'
import { TYPE_NEWS } from '@/shared/constant/cmdtype'
import { COLOR } from '@/shared/constant/color'
import { useNewsListQueryData } from '@/shared/hooks/reactquery'
import useWindowDimensions from '@/shared/hooks/useGetWindowSize'
import { useMoreButton } from '@/shared/hooks/useMoreButton'
import { NewsDetail } from '@/shared/types/type'
import { CustomBtn } from '@/styles/common/CommonForm/buttonform'
import {
  NewsException,
  NewsImg,
  NewsItem,
  NewsItemList,
  NewsTitle,
  NewsWrap,
} from '@/styles/views/Support/News'

const NewsPage = () => {
  const { width } = useWindowDimensions()
  const [more, onChangeMore] = useMoreButton(0)
  const { isLoading, data: NewsListData } = useNewsListQueryData(TYPE_NEWS, more)

  return (
    <>
      {NewsListData?.Body.length !== 0 ? (
        <NewsWrap>
          {isLoading && <Loading />}
          <NewsItemList>
            {NewsListData?.Body.map((news: NewsDetail, index: number) => (
              <NewsItem key={index} href={news.LinkPath} target="_blank">
                <NewsImg src={`${hostImageServer()}${news.ImgPath}`} alt={news.NewsTitle} />
                <NewsTitle>{news.NewsTitle}</NewsTitle>
              </NewsItem>
            ))}
          </NewsItemList>
          {NewsListData?.Body?.length >= (more + 1) * 6 && (
            <CustomBtn
              color={COLOR.point1}
              bgColor={COLOR.white}
              borderColor={COLOR.point1}
              borderRadius={'40px'}
              marginTop={width > 1200 ? '68px' : '38px'}
              width={width > 1200 ? '356px' : '328px'}
              height={width > 1200 ? '56px' : '44px'}
              fontSize={width > 1200 ? '18px' : '14px'}
              fontFamily={
                width > 1200 ? 'NanumSquareNeoHeavy, sans-serif' : 'NotoSansBold, sans-serif'
              }
              onClick={onChangeMore}
            >
              <span>더보기</span>
            </CustomBtn>
          )}
        </NewsWrap>
      ) : (
        <NewsException>
          <img src={news_exception} alt="" />
          <p>서비스 관련 새소식을 준비 중입니다.</p>
        </NewsException>
      )}
    </>
  )
}

export default NewsPage
